import { render, staticRenderFns } from "./OrganisationInfo.vue?vue&type=template&id=a473899a&"
import script from "./OrganisationInfo.vue?vue&type=script&lang=js&"
export * from "./OrganisationInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports